export type TurnstileWidgetTheme = "auto" | "dark" | "light";

export interface ITurnstileChallengeContainer {
    widgetContainer: HTMLElement;
    widgetTheme?: TurnstileWidgetTheme;
    show: () => void;
    remove: () => void;
}

export interface ITurnstileChallengeContainerOptions {
    onDismiss?: () => void;
}

export type CreateTurnstileChallengeContainer = (options?: ITurnstileChallengeContainerOptions) => ITurnstileChallengeContainer;

export const createDefaultTurnstileChallengeContainer: CreateTurnstileChallengeContainer = () => {
    const widgetContainer = document.createElement("div");

    widgetContainer.style.position = "fixed";
    widgetContainer.style.right = "16px";
    widgetContainer.style.bottom = "16px";
    // max 32-bit int = highest z-index browsers support, so the challenge stays above every app overlay
    widgetContainer.style.zIndex = "2147483647";
    document.body.appendChild(widgetContainer);

    return {
        widgetContainer,
        show: () => undefined,
        remove: () => {
            widgetContainer.remove();
        }
    };
};
export type TurnstileWidgetTheme = "auto" | "dark" | "light";

export interface ITurnstileChallengeContainer {
    widgetContainer: HTMLElement;
    widgetTheme?: TurnstileWidgetTheme;
    show: () => void;
    remove: () => void;
}

export interface ITurnstileChallengeContainerOptions {
    onDismiss?: () => void;
}

export type CreateTurnstileChallengeContainer = (options?: ITurnstileChallengeContainerOptions) => ITurnstileChallengeContainer;

export const createDefaultTurnstileChallengeContainer: CreateTurnstileChallengeContainer = () => {
    const widgetContainer = document.createElement("div");

    widgetContainer.style.position = "fixed";
    widgetContainer.style.right = "16px";
    widgetContainer.style.bottom = "16px";
    // max 32-bit int = highest z-index browsers support, so the challenge stays above every app overlay
    widgetContainer.style.zIndex = "2147483647";
    document.body.appendChild(widgetContainer);

    return {
        widgetContainer,
        show: () => undefined,
        remove: () => {
            widgetContainer.remove();
        }
    };
};
